import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { withLayout } from 'pages/Layout'
import ProfilePage from './ProfilePage'

export default withLayout('Profile', withRouter(connect()(ProfilePage)))
